import { useMemo } from 'react';
import { useGetTripStopTypesQuery } from '../../../../../../store/services/tripsApi';
import { ACTIVITY_TYPE_OPTIONS, ActivityType } from '../../../../../../types/activity.types';

export const useActivityTypes = () => {
  const { data: tripStopTypesData, isLoading, error } = useGetTripStopTypesQuery();

  const activityTypes = useMemo((): ActivityType[] => {
    if (tripStopTypesData?.types) {
      return tripStopTypesData.types;
    }
    return ACTIVITY_TYPE_OPTIONS;
  }, [tripStopTypesData]);

  const hasTypes = activityTypes.length > 0;

  return {
    activityTypes,
    isLoading,
    error,
    hasTypes,
  };
};
